
export const CREATE_OR_UPDATE_PROBLEM = 'problems/CREATE_OR_UPDATE_PROBLEM';
export const FETCH_PATIENT_PROBLEMS = 'problems/FETCH_PATIENT_PROBLEMS';
export const FETCH_PATIENT_PROBLEMS_FOR_DROPDOWN = 'problems/FETCH_PATIENT_PROBLEMS_FOR_DROPDOWN';
export const SHARE_PROBLEM = 'problems/SHARE_PROBLEM';
export const UNSHARE_PROBLEM = 'problems/UNSHARE_PROBLEM';
export const DELETE_PROBLEM = 'problems/DELETE_PROBLEM';

const fetchFactory = (type) => (patientId, params = {}) => ({
    type,
    httpRequest: {
        method: 'get',
        path: `/problems/patient/${patientId}`,
        params,
    },
});

export const fetchPatientProblemsForDropdown = fetchFactory(FETCH_PATIENT_PROBLEMS_FOR_DROPDOWN);

export const fetchPatientProblems = fetchFactory(FETCH_PATIENT_PROBLEMS);

export const createOrUpdateProblem = (patientId, data) => ({
    type: CREATE_OR_UPDATE_PROBLEM,
    httpRequest: {
        method: 'post',
        path: `/problems/patient/${patientId}`,
        data,
    },
});

export const shareProblem = (problemId) => ({
    type: SHARE_PROBLEM,
    httpRequest: {
        method: 'put',
        path: `/problems/${problemId}/share`,
    },
});

export const unshareProblem = (problemId) => ({
    type: UNSHARE_PROBLEM,
    httpRequest: {
        method: 'put',
        path: `/problems/${problemId}/unshare`,
    },
});

export const deleteProblem = (problemId) => ({
    type: DELETE_PROBLEM,
    httpRequest: {
        method: 'del',
        path: `/problems/${problemId}`,
    },
    problemId,
});



// WEBPACK FOOTER //
// ./src/reducers/problems/problemsActions.js